import { render, staticRenderFns } from "./configSchoolBadge.vue?vue&type=template&id=55100ce2&scoped=true&"
import script from "./configSchoolBadge.vue?vue&type=script&lang=js&"
export * from "./configSchoolBadge.vue?vue&type=script&lang=js&"
import style0 from "./configSchoolBadge.vue?vue&type=style&index=0&id=55100ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55100ce2",
  null
  
)

export default component.exports